module.exports = __webpack_public_path__ + "static/media/Bulk Upload Stock Dealshub.747a1d0f.xlsx";